import { faKey } from "@fortawesome/pro-solid-svg-icons/faKey";
import * as React from "react";
import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconRole: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faKey} />;
};
